<div class="university-card">
    <!-- Logo -->
    <div class="logo">
        <p-avatar
            *ngIf="!imageError && avatar(); else defaultAvatar"
            [image]="$any(avatar())"
            shape="circle"
            size="large"
            (onImageError)="imageError = true"
        />
        <ng-template #defaultAvatar>
            <p-avatar
                [label]="getInitials(name())"
                [icon]="!name() ? 'pi pi-user' : undefined"
                shape="circle"
                size="large"
            />
        </ng-template>
    </div>

    <!-- Name and Description -->
    <div class="details">
        <h3 class="name">{{ name() }}</h3>
        <p class="description">{{ age() }}</p>
    </div>

    <!-- Contact Details -->
    <div class="contact-info">
        <div class="info-item">
            <div class="icon">
                <img src="icons/globe.svg" alt="Country Icon" />
            </div>
            <span>{{ country() }}</span>
        </div>
        <div class="info-item">
            <div class="icon">
                1
            </div>
            <span>{{ duration() }}</span>
        </div>
    </div>
    <div class="container-estado">
        <div class="estado estado-vinculado">
            <span>{{ estado() }}</span>
        </div>
    </div>

    <!-- Navigation Icon -->
    <div class="navigate">
        <img src="icons/arrow-right.svg" alt="Navigate Icon" />
    </div>
</div>
